import {
  GET_ACTION_HISTORY,
  GET_USERS,
  SET_ACTION_HISTORY,
  SET_USERS,
} from '../constants/ActionHistory';

export const getActionHistory = (params) => {
  return {
    type: GET_ACTION_HISTORY,
    params,
  };
};

export const setActionHistory = (actionHistory) => {
  return {
    type: SET_ACTION_HISTORY,
    actionHistory,
  };
};

export const getUsers = () => {
  return {
    type: GET_USERS,
  };
};

export const setUsers = (users) => {
  return {
    type: SET_USERS,
    users,
  };
};
